import { Flex, Paper, Text, Box, Divider } from "@mantine/core";
import { IconPackage } from "@tabler/icons-react";
import { ProductServiceType } from "@/components/shared/constants/general.const";
import ReadMoreText from "@/components/shared/ReadMoreText";

interface ProductsServicesTabProps {
  company: any;
  isMatchedView?: boolean;
}

export default function ProductsServicesTab({ company }: ProductsServicesTabProps) {
  const productServices = company?.productServices || [];

  const products = productServices.filter((item: any) => item.type === ProductServiceType.PRODUCT);
  const services = productServices.filter((item: any) => item.type === ProductServiceType.SERVICE);

  const renderItems = (items: any[]) => (
    <Flex gap="xl" wrap="wrap">
      {items.map((item: any, index: number) => (
        <Flex key={item.id || index} direction="column" style={{ flex: "1 1 45%", minWidth: "280px", maxWidth: "50%" }}>
          <Text size="xs" c="slate.6" tt="uppercase" mb="xs" fw={400}>
            {item.name || "Untitled"}
          </Text>
          <ReadMoreText text={item.description || ""} />
        </Flex>
      ))}
    </Flex>
  );

  return (
    <Paper p={{ base: "md", sm: "xl" }} radius="lg" mb="xl" style={{ border: "1px solid #E5E7EB" }}>
      <Flex align="center" gap="xs" mb="md">
        <IconPackage size={18} color="#2563EB" />
        <Text size="lg" fw={400}>
          Products & Services
        </Text>
      </Flex>

      <Flex direction="column" gap="lg">
        {products.length > 0 && (
          <Box>
            <Text size="sm" c="slate.8" tt="uppercase" mb="sm" fw={400}>
              PRODUCTS
            </Text>
            {renderItems(products)}
          </Box>
        )}

        {products.length > 0 && services.length > 0 && <Divider />}

        {services.length > 0 && (
          <Box>
            <Text size="sm" c="slate.8" tt="uppercase" mb="sm" fw={400}>
              SERVICES
            </Text>
            {renderItems(services)}
          </Box>
        )}

        {products.length === 0 && services.length === 0 && (
          <Text size="sm" c="slate.6">
            N/A
          </Text>
        )}
      </Flex>
    </Paper>
  );
}
